import { useTranslation } from "react-i18next";
import { typeStateCategories } from "../Layout"

interface ControlProps extends typeStateCategories {}
export const Control = (props: ControlProps) => {
    const { state } = props;
    const [category, setCategory] = state;
    const { t } = useTranslation();
    return (
        <div className="grid-3-col control">
            <div className="form-group videos-color">
                <input hidden type="radio" name="category" id="videos" defaultChecked={category === 'videos'}  onChange={() => setCategory('videos')} />
                <label htmlFor="videos">
                    <div className="icon-bg">
                        <span className="large icon--ri video-line"></span>
                    </div>
                    {t('Videos')}<br />
                    <small className="text-align-center">{t("Größte exklusive Video Sammlung der Models")}</small>
                    <div className="border-indicator videos-color"></div>
                </label>
            </div>
            <div className="form-group livecams-color">
                <input hidden type="radio" name="category" id="livecams" defaultChecked={category === 'livecams'} onChange={() => setCategory('livecams')} />
                <label htmlFor="livecams">
                    <div className="icon-bg">
                        <span className="large icon--ri live-line"></span>
                    </div>
                    {t('Livecams')}<br />
                    <small className="text-align-center">{t("Schaue & Chatte Live mit den Models")}</small>
                    <div className="border-indicator livecams-color"></div>
                </label>
            </div>
            <div className="form-group chatting-color">
                <input hidden type="radio" name="category" id="chatting" defaultChecked={category === 'chatting'} onChange={() => setCategory('chatting')} />
                <label htmlFor="chatting">
                    <div className="icon-bg">
                        <span className="large icon--ri chat-3-line"></span>
                    </div>
                    {t('Chatting')}<br />
                    <small className="text-align-center">{t("1:1 Private Chatting im Messenger")}</small>
                    <div className="border-indicator chatting-color"></div>
                </label>
            </div>
        </div>
    )
}